module.exports = __webpack_public_path__ + "static/media/delete.3cc71eed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/delete.svg
// module id = 190
// module chunks = 5